import { makeStyles, Theme } from '@material-ui/core/styles';

export default makeStyles((theme: Theme) => ({
  whiteButton: {
    background: theme.palette.white.main,
    color: theme.palette.primary.main,
    marginTop: theme.spacing(2)
  }
}));
